import { render, staticRenderFns } from "./AdminUserView.vue?vue&type=template&id=77bfd96c"
import script from "./AdminUserView.vue?vue&type=script&lang=js"
export * from "./AdminUserView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports